/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {ReplicationStateSession} from "../model/replication-state-session";
import {SetAccessTimeForSessionDto} from "../model/set-access-time-for-session-dto";
import {SimulationEventReplicationInfo} from "../model/simulation-event-replication-info";

@Injectable({
    providedIn: "root",
})
export class SimStudentPortalService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
/**
 * Get the replication state for a session.
 */ 

    public getReplicationStateForSession(sessionId: string) {
        return super.get<ReplicationStateSession>(`/api/StudentPortal/GetReplicationStateForSession`, {sessionId: sessionId});
    }
/**
 * Set access time for session by session id
 */ 

    public setAvailabilityForSession(setAccessTimeForSessionDto: SetAccessTimeForSessionDto) {
        return super.post<void>(`/api/StudentPortal/SetAvailabilityForSession`, setAccessTimeForSessionDto);
    }
/**
 * Trigger or retrigger the replication and data sync for a specific session.
 */ 

    public triggerReplicationAndDataSyncForSession(sessionId: string, syncAll: boolean = false) {
        return super.post<void>(`/api/StudentPortal/TriggerReplicationAndDataSyncForSession/${encodeURIComponent(sessionId)}`, {}, {syncAll: syncAll});
    }
/**
 * TESTING METHOD: Replicate an event and its sessions to the student portal.
 */ 

    public triggerReplicationNewStructure(eventId: string) {
        return super.get<SimulationEventReplicationInfo>(`/api/StudentPortal/TriggerReplicationNewStructure/${encodeURIComponent(eventId)}`, );
    }

    public triggerReplicationToStudentPortalChangesOnly() {
        return super.get<void>(`/api/StudentPortal/TriggerReplicationToStudentPortalChangesOnly`, );
    }
}